import demo from './../demo.scss'
import demoAddress from './demo-address.scss'
import template from "./demo-address.html";

const styles = {
    demo: demo,
    demoAddress: demoAddress
};

export class DemoAddress {
    static $inject = [];

    styles = styles;
    restrict = "EA";
    template = template;
    replace = false;
    controller = DemoAddressController;
    controllerAs = "controller";
    scope = {};
    bindToController = {
        header: "@",
        addressObject: "="
    };

    link = (scope, element: ng.IAugmentedJQuery, attrs) => {};
}

export class DemoAddressController {

}
